import { useRef } from "react";
import "./Slide.css";

export default function Slide({ title, items }) {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const amount = 300;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  return (
    <div className="slide-container">
      <div className="slide-header">
        <h2 className="slide-title-main">{title}</h2>

        <div className="slide-buttons">
          <button onClick={() => scroll("left")} className="arrow-btn">◀</button>
          <button onClick={() => scroll("right")} className="arrow-btn">▶</button>
        </div>
      </div>

      <div className="slide-content" ref={scrollRef}>
        {items.map((item, index) => (
          <div className="slide-card" key={index}>
            <img src={item.img} alt={item.title} className="slide-img" />
            <h3 className="slide-card-title">{item.title}</h3>
            <p className="slide-card-sub">{item.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
